// @react-native-clipboard/clipboard stand-in over navigator.clipboard.

export const Clipboard = {
  setString(text: string): void {
    void navigator.clipboard?.writeText(text).catch(() => undefined);
  },
  async getString(): Promise<string> {
    try {
      return (await navigator.clipboard?.readText()) ?? '';
    } catch {
      return '';
    }
  },
  async hasString(): Promise<boolean> {
    return (await Clipboard.getString()).length > 0;
  },
};

export default Clipboard;
